import React, { ElementType } from 'react';
import { EventRegistrationFormField } from '../generated/api/dsv-public/model';

type FieldComponentProps = {
  componentType: ElementType;
  fieldProps: EventRegistrationFormField;
  onChangeFieldValue: (field: string, value: any) => void;
};

export const FieldComponent: React.FC<FieldComponentProps> = ({ componentType, fieldProps, onChangeFieldValue }) => {
  const Component = componentType;
  return <Component {...fieldProps} fieldKey={fieldProps.key} onChangeFieldValue={onChangeFieldValue} />;
};
